import { v5 as uuidv5 } from 'uuid';

// [CORE-547] Deterministic per-cart idempotency key for booking/special-event deposits.
// An idempotency key identifies a payment INTENT (this cart's deposit), not an attempt: deriving it
// from the cart cookie means every retry — including after a page refresh — presents the SAME key,
// so the backend can collapse/resume an already-captured deposit instead of charging again. Genuine
// retries after a decline still work: the backend sends JustiFi a derived per-attempt processor key
// (CORE-524) while the invoice row keeps this stable key.
export function bookingDepositIdempotencyKey(cookieId: string): string {
  return uuidv5('booking-deposit', cookieId);
}
